const truncate = (str, maxLen) =>
  str?.length > maxLen ? `${str.substr(0, maxLen - 1)}…` : str;

export default truncate;
